import { render, staticRenderFns } from "./LoadingPage.vue?vue&type=template&id=a7d3d7d2"
import script from "./LoadingPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingPage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports